export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                {/* <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1> */}
                <h1> <span className="g">G</span> <span className="d">D</span> <span className="s">S</span> <span className="c">C</span>      <span className="z">Z</span> <span className="h">H</span> <span className="cc">C</span> <span className="e">E</span> <span className="t">T</span></h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p>
                <a
                  href='https://gdsc.community.dev/zakir-husain-college-of-engineering-and-technology-aligarh/'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  Become a member
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
